"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var recharts_1 = require("recharts");

var styled_1 = require("./styled");
/**
 * Pie Chart component
 *
 * Extended and customized PieCHart `recharts` http://recharts.org/en-US/api/PieChart
 *
 */


var PieChart = function PieChart(_ref) {
  var size = _ref.size,
      _ref$legend = _ref.legend,
      legend = _ref$legend === void 0 ? false : _ref$legend,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      data = _ref.data,
      _ref$innerRadius = _ref.innerRadius,
      innerRadius = _ref$innerRadius === void 0 ? "92%" : _ref$innerRadius,
      _ref$outerRadius = _ref.outerRadius,
      outerRadius = _ref$outerRadius === void 0 ? "100%" : _ref$outerRadius,
      _ref$paddingAngle = _ref.paddingAngle,
      paddingAngle = _ref$paddingAngle === void 0 ? 0 : _ref$paddingAngle,
      _ref$startAngle = _ref.startAngle,
      startAngle = _ref$startAngle === void 0 ? 90 : _ref$startAngle,
      _ref$endAngle = _ref.endAngle,
      endAngle = _ref$endAngle === void 0 ? -360 : _ref$endAngle;
  return react_1["default"].createElement(styled_1.Wrapper, null, react_1["default"].createElement(styled_1.ChartWrapper, {
    size: size
  }, label !== null && react_1["default"].createElement(styled_1.Label, null, label), react_1["default"].createElement(recharts_1.PieChart, {
    width: size,
    height: size
  }, react_1["default"].createElement(recharts_1.Pie, {
    data: data,
    dataKey: "value",
    nameKey: "name",
    cx: "50%",
    cy: "50%",
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    paddingAngle: paddingAngle,
    blendStroke: true,
    startAngle: startAngle,
    endAngle: endAngle
  }, data.map(function (_ref2) {
    var color = _ref2.color,
        name = _ref2.name;
    return react_1["default"].createElement(recharts_1.Cell, {
      key: name,
      fill: color
    });
  })))), legend === true && react_1["default"].createElement(styled_1.Legend, null, data.map(function (_ref3) {
    var name = _ref3.name,
        color = _ref3.color;
    return react_1["default"].createElement(styled_1.LegendItem, {
      key: name
    }, react_1["default"].createElement(styled_1.LegendCircle, {
      color: color
    }), name);
  })));
};

exports["default"] = PieChart;